import { render, staticRenderFns } from "./BasicNavbar.vue?vue&type=template&id=00067598"
import script from "./BasicNavbar.vue?vue&type=script&lang=js"
export * from "./BasicNavbar.vue?vue&type=script&lang=js"
import style0 from "./BasicNavbar.vue?vue&type=style&index=0&id=00067598&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports